import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { AuthService } from './modules/auth/auth.service'

@Injectable({ providedIn: 'root' })
export class LogoutGuard {
	private readonly authService = inject<AuthService>(AuthService)
	private readonly router = inject<Router>(Router)

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.authService.logout(false).then(() => this.router.parseUrl('auth'))
	}
}
